/**
 * Leaflet + OSM provider — the default. Thin wrapper around the existing
 * `components/MapView.jsx` so nothing visual changes today. This provider
 * self-registers on import.
 */
import React from "react";
import MapView from "@/components/MapView";
import { registerMapProvider } from "@/components/map/MapProvider";

function LeafletProvider(props) {
  // The legacy MapView already accepts { center, markers, height, zoom, tracking }
  // — we just pass everything through and drop provider-specific extras (e.g.
  // onMarkerClick / onMapClick) that the underlying Leaflet layer doesn't wire
  // yet. Those will be layered in during the iteration-46 Personal Map rebuild.
  return <MapView {...props} />;
}

registerMapProvider({
  id: "leaflet",
  name: "Leaflet + OSM",
  available: () => true,   // no keys required
  Component: LeafletProvider,
});

export default LeafletProvider;
